import { render, staticRenderFns } from "./Educations.vue?vue&type=template&id=3bafeec0&scoped=true&"
import script from "./Educations.vue?vue&type=script&lang=ts&"
export * from "./Educations.vue?vue&type=script&lang=ts&"
import style0 from "./Educations.vue?vue&type=style&index=0&id=3bafeec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bafeec0",
  null
  
)

export default component.exports